import React from 'react'
import PrintTable from './PrintTable'

const PrintResults = ({ history }) => {
  const [results, setResults] = React.useState(null)

  React.useEffect(() => {
    window.setPrintResults = setResults
    if (window.opener.onPrintPageReady) {
      window.opener.onPrintPageReady()
    } else {
      history.replace('/')
    }
    return () => {
      delete window.setPrintResults
    }
  }, [])

  console.log('Results', results)
  return (
    <div>
      {results ? 
        <PrintTable 
          template={results.template} 
          rows={results.rows} 
        /> 
      : null}
    </div>
  )
}

export default PrintResults
